import { EnumEndpointsName } from "@/constants/app/type";
import { AsyncThunk, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { services } from "../services";

export type ThunkInput = {
  params?: { customEndpoint?: (endpoint: string) => string } & Record<string, any>,
  body?: any,
  headers?: any,
}

export type TypeThunks = {
  [prop in EnumEndpointsName]: AsyncThunk<any, ThunkInput, any>
}

export const thunks = Object.values(EnumEndpointsName).reduce(
  (reducedThunks: TypeThunks, endpointName) => {
    reducedThunks[endpointName] = createAsyncThunk(endpointName, async (input: ThunkInput, thunkAPI) => {
      try {
        const source = axios.CancelToken.source();
        thunkAPI.signal.addEventListener('abort', () => {
          source.cancel();
        });

        const response: any = await services[endpointName]({ params: input.params, body: input.body }, input.headers);

        return response;
      } catch (err) {
        throw thunkAPI.rejectWithValue(err)
      }
    })
    return reducedThunks
  },
  {} as TypeThunks
)